// extracted by mini-css-extract-plugin
module.exports = {"switch-label":"toggle_switch-label__dQO-u","switch-background":"toggle_switch-background__17n1i","switch-dot":"toggle_switch-dot__Dc-2z"};